<template>
  <v-container fluid>
    <v-dialog v-model="custfilterdialog" max-width="600">
      <Customerfilters v-on:hideCustFilters="hideCustFilters()" />
    </v-dialog>
    <v-dialog v-model="contselectdialog" max-width="450">
      <Contselect
        v-on:contOutNewIn="contOutNewIn()"
        v-on:NewOutMsgIn="NewOutMsgIn()"
        v-on:close="closeContDialog"
      />fluid
    </v-dialog>
    <v-dialog v-model="contadddialog" max-width="550">
      <Newcontact v-on:NewContOut="NewContOut()" />
    </v-dialog>
    <v-dialog v-model="showPop" max-width="450">
      <Popup />
    </v-dialog>
    <v-dialog v-model="custproductsdialog" persistent max-width="650">
      <Customerproducts v-on:hideCustProd="hideCustProd()" />
    </v-dialog>
    <v-dialog v-model="custstmtdialog" persistent max-width="550">
      <Customerstatement v-on:hideCustStmt="hideCustStmt()" />
    </v-dialog>
    <v-dialog v-model="journalslistdialog"  persistent max-width="550">
      <Journalslist v-on:addNewJournal="showCustomerContacts(selectedcust)" v-on:close="hideJournalslist()"/>
    </v-dialog>
    <v-row class="d-flex" dense>
      <v-col cols="2" class="d-flex justify-center">
        <v-btn color="primary" @click="showCustFilters" icon fab>
          <v-icon>
            mdi-filter-menu-outline
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="8" class="d-flex align-center">
        <v-text-field
          v-model="custsearch"
          clearable
          label="Search in list"
          type="text"
          class="mt-2 Caption"
          condensed
          outlined
        />
      </v-col>
      
      <v-col cols="2" class="d-flex justify-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" icon fab>
              <v-icon>
                mdi-sort
              </v-icon>
            </v-btn>
          </template>
          <v-list v-for="custsortitem in custsort" :key="custsortitem.sortval">
            <v-list-item
              @click="sortCustomers(custsortitem.sortby, custsortitem.sortord)"
            >
              {{ custsortitem.sortdesc }}
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>

    <!-- <div class="mt-3" 
        v-for="customer in matches" 
        :key="customer.CustomerCode"> -->
      <v-row>
        <v-col
          v-for="customer in matches"
          :key="customer.CustomerCode"
          cols="12" sm="6" md="4" class="pa-3 mb-2">
        <Customercard
          :custname="customer.PARTYMST_DESC"
          :custblock="customer.PARTYMST_TRANSACTION_STOP"
          :custthismonthyield="customer.PROFIT_THIS_MONTH"
          :custthismonthsale="customer.SALE_THIS_MONTH"
          :custavgsale="customer.AVG_SALE"
          :custouts="customer.CUSTOUTS_OUTSTANDING"
          :custpdc="customer.CUSTOUTS_PDC"
          :custabv45="customer.CUSTOUTS_OUTSTANDING_ABOVE45"
          :custCrLimit="customer.PARTYMST_CR_LIMIT"
          :custMstPDC="customer.PARTYMST_PDC_AMT"  
          :custCurrType="customer.PARTYMST_CURR_DOCNO"        
          v-on:showCustomerContacts="showCustomerContacts(customer)"
          v-on:showCustomerProducts="showCustomerProducts(customer)"
          v-on:showCustomerOutsDocs="showCustomerOutsDocs(customer)"
          v-on:showCustomerJournals="showCustomerJournals(customer)"
        />
        </v-col>
      </v-row>
    <!-- </div> -->
  </v-container>
</template>

<script>
import Customercard from "@/components/Customercard";
import Contselect from "@/components/Contselect";
import Customerfilters from "@/components/Customerfilters";
import Customerstatement from "@/components/Customerstatement";
import Customerproducts from "@/components/Customerproducts";
import Newcontact from "@/components/Newcontact";
import Popup from "@/components/Popup";
import Journalslist from "@/components/Journalslist"

export default {
  components: {
    Customercard,
    Contselect,
    Newcontact,
    Customerfilters,
    Customerstatement,
    Customerproducts,
    Popup,
    Journalslist,
  },
  data() {
    return {
      contselectdialog: false,
      contadddialog: false,
      custfilterdialog: false,
      custstmtdialog: false,
      custproductsdialog: false,
      journalslistdialog: false,
      custsearch: null,
      custsort: [
        {
          sortval: 0,
          sortdesc: "Highest Avg Sale first",
          sortby: "AVG_SALE",
          sortord: -1,
        },
        {
          sortval: 1,
          sortdesc: "Lowest Avg Sale first",
          sortby: "AVG_SALE",
          sortord: 1,
        },
        {
          sortval: 2,
          sortdesc: "Highest Outstanding first",
          sortby: "CUSTOUTS_OUTSTANDING",
          sortord: -1,
        },
        {
          sortval: 3,
          sortdesc: "Lowest Outstanding first",
          sortby: "CUSTOUTS_OUTSTANDING",
          sortord: 1,
        },
        {
          sortval: 4,
          sortdesc: "Earliest Invoice date first",
          sortby: "FIRST_INVOICE_DATE",
          sortord: 1,
        },
        {
          sortval: 5,
          sortdesc: "Latest Invoice date first",
          sortby: "LAST_INVOICE_DATE",
          sortord: -1,
        },
      ],
    };
  },
  computed: {
    showPop() {
      return this.$store.getters.showPop;
    },
    selectedcust() {
      return this.$store.getters.thiscustomer;
    },
    customersdatalist() {
      return this.$store.getters.customersdata;
    },
    customersproductslist() {
      return this.$store.getters.customerproducts;
    },
    contacts() {
      return this.$store.getters.allcontacts;
    },
    matches() {
      if (this.custsearch == null) {
        return this.customersdatalist;
      } else {
        return this.customersdatalist.filter((customer) =>
          customer.PARTYMST_DESC.toLowerCase().includes(
            this.custsearch.toLowerCase()
          )
        );
      }
    },
  },
  methods: {
    getCustomersData() {
      this.$store.dispatch("getCustomersData", {
        smandocno: this.$store.getters.salesperson,
        search: "",
        doctype: "",
        docno: "",
        blockstat: "",
        lastinv: "",
        oldinv: "",
        skip: 0,
        sortby: "",
        sortord: "",
      });                                  
    },
    showCustomerContacts(customer) {
      this.$store.dispatch("selectThisCustomer", customer);
      this.$store.dispatch("clearAllContacts");
      this.$store.dispatch("getAllContacts", {
        accondoctype: customer.PARTYMST_DOCTYPE,
        accondocno: customer.PARTYMST_DOCNO,
      });
      this.contselectdialog = true;
    },
    showCustomerProducts(customer) {
      this.$store.dispatch("selectThisCustomer", customer);
      this.$store.dispatch("getAllCustProducts", {
        doctype: customer.PARTYMST_DOCTYPE,
        docno: customer.PARTYMST_DOCNO,
      });
      this.custproductsdialog = true;
      console.log(this.customersproductslist);
    },
    showCustomerOutsDocs(customer) {
      this.$store.dispatch("selectThisCustomer", customer);
      this.$store.dispatch("getCustomerOutsDocs", {
        doctype: customer.PARTYMST_DOCTYPE,
        docno: customer.PARTYMST_DOCNO,
      });
      this.custstmtdialog = true;
    },
    showCustomerJournals(customer) {
      this.$store.dispatch("selectThisCustomer", customer);
      this.$store.dispatch("getAllJournals", {
        acdoctype: customer.PARTYMST_DOCTYPE,
        acdocno: customer.PARTYMST_DOCNO,
      });
      this.journalslistdialog = true;
    },
    showCustFilters() {
      this.custfilterdialog = true;
    },
    hideCustFilters() {
      this.custfilterdialog = false;
    },
    hideCustStmt() {
      this.custstmtdialog = false;
    },
    hideCustProd() {
      this.custproductsdialog = false;
    },
    hideJournalslist(){
      this.journalslistdialog= false
    },
    sortCustomers(sortby, sortord) {
      return this.customersdatalist.sort(function(a, b) {
        return a[sortby] > b[sortby] ? sortord : -1 * sortord;
      });
    },
    contOutNewIn() {
      this.contselectdialog = false;
      this.contadddialog = true;
    },
    NewContOut() {
      this.contadddialog = false;
    },
    closeContDialog() {
      this.contselectdialog = false;
    },
  },
  created() {
    this.getCustomersData();
  },
};
</script>

<style lang="scss" scoped></style>
